import './Seo.scss';

import { Component } from '../../../components/Component';
import { FiSubHeaderService } from '../../../components/FiSubHeader/FiSubHeaderService';
import { FiFurnitureService } from '../../../components/fiFurniture/FiFurnitureService';
import * as angular from 'angular';
import { IUser } from '../../../components/fiFurniture/FiFurnitureService';

@Component({
    controllerAs: 'vm',
    template: require('./Seo.html'),
    bindings: {
    }
})
export class Seo {
    static $inject = [
        'fiSubHeaderService',
        '$window',
        '$http',
        'fiFurnitureService',
        '$mdDialog',
    ];


    constructor(
        private fshs: FiSubHeaderService,
        private $window: angular.IWindowService,
        private $http: angular.IHttpService,
        private fs: FiFurnitureService,
        private $mdDialog: angular.material.IDialogService,
    ) {
        /* */
    }

    private user: any;
    pages = [];

    $onInit() {
        this.fshs.subHeaderIsHidden = false;

        this.user = JSON.parse(localStorage.getItem('currentUser'));

        if (!this.user || !this.user.admin) {
            this.$window.location.href = '/';
        } else {
            this.$http.get('https://www.fitit.lt/db/seo-list.php').then((data) => {
                this.pages.push(data);
            });
        }
    }

    showSeoPageDialog(page) {
    
        this.fs.seoPage = page;

        this.$mdDialog.show({
            template: '<fi-seo-page-dialog></fi-seo-page-dialog>',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            controllerAs: 'vm'
        });
    }

    switchVisibility(id, follow) {
    
        follow = follow == 0 ? 1 : 0;

        this.$http.post("https://www.fitit.lt/db/seo-page-visibility.php", { 

            id: id,
            follow: follow

        }, { headers: {'Content-Type': 'application/json'} })
            .then((response: any) => {

            location.reload();        
                
            }
        );
        
    }

    addSeoPage() {
    
        this.$mdDialog.show({
            template: '<fi-add-seo-page-dialog></fi-add-seo-page-dialog>',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            controllerAs: 'vm'
        });
    }
}
